import React from "react";
import { motion } from "framer-motion";

const ReactionSpeedGraph: React.FC = () => {
    return (
        <div className="space-y-3" dir="rtl">
            <div className="flex items-center justify-between">
                <span>واکنش بصری</span>
                <span className="font-medium text-[#32D74B]">۲۱۳ میلی‌ثانیه</span>
            </div>
            <div className="w-full bg-[#ECEFF1] rounded-full h-2">
                <motion.div className="bg-[#32D74B] h-2 rounded-full" initial={{ width: 0 }} animate={{ width: "75%" }} transition={{ duration: 0.2, ease: [0.4, 0.0, 0.2, 1] }} />
            </div>

            <div className="flex items-center justify-between pt-1">
                <span>واکنش شنیداری</span>
                <span className="font-medium text-[#00E5FF]">۱۸۹ میلی‌ثانیه</span>
            </div>
            <div className="w-full bg-[#ECEFF1] rounded-full h-2">
                <motion.div
                    className="bg-[#00E5FF] h-2 rounded-full"
                    initial={{ width: 0 }}
                    animate={{ width: "85%" }}
                    transition={{
                        duration: 0.2,
                        delay: 0.05,
                        ease: [0.4, 0.0, 0.2, 1],
                    }}
                />
            </div>

            <div className="flex items-center justify-between pt-1">
                <span>واکنش لمسی</span>
                <span className="font-medium text-[#FF4F00]">۲۲۶ میلی‌ثانیه</span>
            </div>
            <div className="w-full bg-[#ECEFF1] rounded-full h-2">
                <motion.div
                    className="bg-[#FF4F00] h-2 rounded-full"
                    initial={{ width: 0 }}
                    animate={{ width: "68%" }}
                    transition={{
                        duration: 0.2,
                        delay: 0.1,
                        ease: [0.4, 0.0, 0.2, 1],
                    }}
                />
            </div>
        </div>
    );
};

export default ReactionSpeedGraph;
